const productCopy = {
  1: { category: 'looping', details: 'blitz' },
  3: { category: 'looping', details: 'standard' },
  4: { category: 'looping', details: 'standard' },
  5: { category: 'looping', details: 'standard' },
  6: { category: 'looping', details: 'standard' },
  8: { category: 'looping', details: 'wind' },
  9: { category: 'looping', details: 'standard' },
  10: { category: 'parts', details: 'thinString' },
  11: { category: 'parts', details: 'blitzSpacer' },
  12: { category: 'parts', details: 'shim' },
  13: { category: 'parts', details: 'windSpacer' },
  14: { category: 'offstring', details: 'hidden' },
  15: { category: 'parts', details: 'loop720' },
  16: { category: 'parts', details: 'basic' },
  17: { category: 'parts', details: 'pad' },
  18: { category: 'parts', details: 'bearing' },
  19: { category: 'parts', details: 'thickString' },
  20: { category: 'looping', details: 'infinity' },
  21: { category: 'looping', details: 'wind' },
  22: { category: 'string', details: 'sunshine' },
  23: { category: 'parts', details: 'pom' },
};

const curatedSources = {
  "1": {
    "sourceName": "Blitzball Ver 2.0",
    "sourceDescription": "A high-performance yo-yo designed by Chenghao Yi, the six-time China National Champion and Asian Champion. Perfect for those who aspire to take their yo-yo skills to the next level.\n\n$10.99 Version: Default setup: Gold spacer + Black spacer. Additional includes: 2 Large shims, 2 Small shims for axle gap adjustment.\n$11.99 Version: Default setup: Gold spacer + Black spacer. Additional includes: 2 Large shims, 2 Small shims, and 1 Purple spacer for axle gap adjustment.",
    "sourceInclude": "$10.99 Version: Default setup: Gold spacer + Black spacer. Additional includes: 2 Large shims, 2 Small shims for axle gap adjustment.\n$11.99 Version: Default setup: Gold spacer + Black spacer. Additional includes: 2 Large shims, 2 Small shims, and 1 Purple spacer for axle gap adjustment.",
    "sourceColors": [
      "Deep Blue - Yellow Cap Black Text",
      "Fluorescent Yellow - Black Text",
      "Transparent White - Black Text",
      "Transparent White - Rose Red Text",
      "Transparent White - White Cap Black Text",
      "Transparent White - Yellow Cap Black Text",
      "Solid Pink - Transparent Cap Black Text",
      "Solid Pink Rose Red Text",
      "Solid Pink White Cap Black Text"
    ]
  },
  "3": {
    "sourceName": "BlitzBall ver2.0 Gold & White logo",
    "sourceDescription": "Experience premium quality and style with the Gold & Silver edition, crafted for both beginners and seasoned players.",
    "sourceInclude": "Default setup: Gold spacer + Black spacer. Additional includes: 2 Large shims, 2 Small shims, and 1 Purple spacer for axle gap adjustment.",
    "sourceColors": [
      "Clear Red-Black Cap-White Logo",
      "All Clear Blue-White Logo",
      "Clear Green-Black Cap-White Logo",
      "Clear Green-Black Cap-Gold Logo",
      "Clear Green-Red Cap-White Logo",
      "All Clear Red-Gold Logo",
      "All Clear Red-White Logo",
      "Clear-Clear Blue Cap-White Logo",
      "Clear-Black Cap-White Logo",
      "White-Black Cap-White Logo",
      "White-Clear Red Cap-Gold Logo",
      "White-Clear Red Cap White Logo",
      "White-Clear Blue Cap-White Logo",
      "All Black-Gold Logo",
      "All Black-White Logo"
    ]
  },
  "4": {
    "sourceName": "v12",
    "sourceDescription": "Inspired by the power and precision of V12 car engines, this yo-yo delivers unmatched performance with a sleek design.",
    "sourceInclude": "Default setup: Gold spacer + Black spacer. Additional includes: 2 Large shims, 2 Small shims, and 1 Purple spacer for axle gap adjustment.",
    "sourceColors": [
      "Large V Transparent Green Silver",
      "Large V Transparent Green Black Cap Silver",
      "Large V Transparent Red Silver",
      "Small V Transparent Green Silver",
      "Small V Transparent Green Black Cap Silver",
      "Small V Transparent Red Silver"
    ]
  },
  "5": {
    "sourceName": "ROCK HOUSE x Principal Qiao Signature Yo-Yo",
    "sourceDescription": "A signature yo-yo designed in collaboration with Principal Qiao, a dance master, combining rhythm and precision for a unique playing experience.",
    "sourceInclude": "Default setup: Gold spacer + Black spacer. Additional includes: 2 Large shims, 2 Small shims, and 1 Purple spacer for axle gap adjustment.",
    "sourceColors": [
      "Solid White Pink Text",
      "Deep Red White",
      "Fluorescent Green Black Text",
      "Transparent Black Text",
      "Solid Black Pink Text"
    ]
  },
  "6": {
    "sourceName": "Destiny - Zirui Qiu Signature Yo-Yo",
    "sourceDescription": "Designed for champions, this yo-yo pays tribute to Zirui Qiu with precision engineering and an inspiring look.",
    "sourceInclude": "Default setup: Gold spacer + Black spacer. Additional includes: 2 Large shims, 2 Small shims, and 1 Purple spacer for axle gap adjustment.",
    "sourceColors": [
      "main",
      "Thank you for supporting Zirui Qiu"
    ]
  },
  "8": {
    "sourceName": "Wind Ball",
    "sourceDescription": "Designed for speed, the Wind Ball is a high-performance yo-yo perfect for mastering fast-paced 2A division tricks.",
    "sourceInclude": "Default setup: Orange Red spacer + Deep Blue spacer( both not fit to BlitzBall). Additional 6 shims includeed: 2 Large shims(0.1mm), 2 Small shims(0.1mm), 2 Special shims(0.05mm).",
    "sourceColors": [
      " All Clear-Black Logo",
      "All Orange-Black Logo",
      "All Pearlescent Blue-White Logo",
      "All Pearlescent Green-White Logo",
      "All Pearlescent Blue-Black Logo",
      "All Pearlescent Green-Black Logo",
      "All Black-White Logo",
      "All White-Black Logo",
      "All Red-Black Logo",
      "All Red-White Logo",
      "Black-White Cap-Black Logo",
      "White-Clear Red Cap-White Logo",
      "White-Clear Blue Cap-White Logo",
      "White-Black Cap-White Logo",
      "White-Clear Cap-Black Logo",
      "Clear-White Cap-Black Logo",
      "Clear-Clear Red Cap-White Logo",
      "Clear-Clear Blue Cap-White Logo",
      "Clear-Neon Yellow Cap-Black Logo",
      "Jade Blue-White Cap-Black Logo",
      "Jade Blue-Clear Cap-Black Logo",
      "Pearlescent Red-White Cap-Black Logo",
      "Pearlescent Red-Black Cap-White Logo",
      "Jade Pink-White Cap-Black Logo",
      "Jade Pink-Clear Cap-White Logo",
      "Jade Pink-Clear Cap-Black Logo",
      "Solid Pink-White Cap-Black Logo",
      "Solid Pink-Clear Cap-Black Logo",
      "Solid Pink-Clear Black Cap-White Logo",
      "Neon Yellow-Clear Cap-Black Logo",
      "Neon Yellow-Black Cap-White Logo",
      "Neon Yellow-Clear Red Cap-White Logo",
      "Neon Yellow-White Cap-Black Logo"
    ]
  },
  "9": {
    "sourceName": "Valentines Gift",
    "sourceDescription": "Celebrate love and yo-yoing with the Valentine's Gift edition, available in charming designs and colors.",
    "sourceInclude": "Default setup: Gold spacer + Black spacer. IncluAdditional includesdes: 2 Large shims, 2 Small shims, and 1 Purple spacer for axle gap adjustment.",
    "sourceColors": [
      "Solid White Blue Text",
      "Solid White Pink Text",
      "Transparent White Blue Text",
      "Transparent White Pink Text"
    ]
  },
  "10": {
    "sourceName": "2A String x100",
    "sourceDescription": "High-quality thin strings optimized for 2A division yo-yos, ensuring smooth and responsive play.\nT-18 is the thinnest, T-20 is the medium, and T-22 is the thickest. \nReference: T-18 is fit for BlitzBall, and T-22 is fit for WindBall. ",
    "sourceInclude": "100 strings",
    "sourceColors": [
      "White(T-18,fit for BlitzBall)",
      "White(T-20, fit for Loop Infinity S)",
      "White(T-22, fit for WindBall)"
    ]
  },
  "11": {
    "sourceName": "2A Metal Spacer for Blitzball (2pcs)",
    "sourceDescription": "Enhance your Blitzball's performance with these precision-engineered metal spacers available in rebound options.",
    "sourceInclude": "2pcs",
    "sourceColors": [
      "Purple (weak response)",
      "Black (strong response)",
      "Gold (Standard response)"
    ]
  },
  "12": {
    "sourceName": "2A Shim (4pcs)",
    "sourceDescription": "Achieve the perfect balance and gap width with these durable shims designed for most M4-axle 2A yo-yos.\nThickness: 0.1mm\\0.05mm\nBig shims: installed at the botton of spacers\nSmall shims: installed on the front of spacers",
    "sourceInclude": "4pcs",
    "sourceColors": [
      "0.1mm Big and Small Shims (2+2pcs)",
      "0.05mm Big Shims (Ultrathin，4pcs)"
    ]
  },
  "13": {
    "sourceName": "2A Metal Spacer for Wind Ball (2pcs)",
    "sourceDescription": "Enhance your Wind Ball's performance with these precision-engineered metal spacers available in rebound options.\n\nBy swapping the spacers, the gap width changes, allowing you to adjust the feel.\n\nGap width order (Top is the widest with the weakest return. Bottom is the narrowest with the strongest return):\n\nCyan\nOrange\nRed\nGreen\nBlue\nSilver",
    "sourceInclude": "2pcs",
    "sourceColors": [
      "Orange",
      "Blue",
      "Cyan",
      "Red",
      "Silver",
      "Green"
    ]
  },
  "14": {
    "sourceName": "Hidden Loong",
    "sourceDescription": "Hidden Loong (Chinese name: Qian Loong / 潜龙) is a high-performance offstring yo-yo designed with a clear and focused philosophy: to make an excellent offstring yo-yo accessible to everyone.\n\nDesigned by Ouyang Shuntao, a multiple-time Chinese National Champion in offstring yo-yo competitions, Hidden Loong reflects years of top-level competitive experience and real-world practice.\n\nHidden Loong successfully balances single-yo-yo and double-yo-yo compatibility, offering outstanding versatility without compromising durability. Its stable structure and carefully tuned performance ensure a long service life, making it equally suitable for daily practice and high-pressure competition environments. Whether you are refining fundamentals or performing on stage, Hidden Loong remains consistent, reliable, and easy to control.\n\nThe design concept behind Hidden Loong is simple yet ambitious:\nto allow every offstring player to own a yo-yo with truly competitive performance—one that grows with the player and performs when it matters most.\n\nHidden Loong is not just a piece of equipment; it is a dependable partner for offstring players at every level.",
    "sourceInclude": "One pack of string",
    "sourceColors": [
      "Red",
      "Purple",
      "Transparent Pink",
      "Black",
      "Light Blue",
      "Transparent White",
      "Transparent Blue",
      "Transparent Yellow"
    ]
  },
  "15": {
    "sourceName": "2A accessories for Loop 720(Third Party Version)",
    "sourceDescription": "These 2A accessories are fit for YYF loop 720, Blackcat, GO! and Ten Trick!. \n\nYou can choose one of the accessroies, or choose the package.\n\nThe packages includes:\nspacers(4pcs)\naxles(2pcs)\nbig shims(4pcs)\nsmall shims(4pcs)\nbearings(2pcs)",
    "sourceInclude": "spacers, axles, bearings and shims",
    "sourceColors": [
      "red spacer(2pcs)",
      "axle(1pcs)",
      "package(spacers, axles, bearings and shims)"
    ]
  },
  "16": {
    "sourceName": "Basic Metal Spacer for Windball",
    "sourceDescription": "This spacer is fit for Windball.\n\nIt is not 2A spacer, but Basic spacer.\n\nIf you install it on your Windball, your Windball will become a Basic yo-yo.\n\nQ: What is Basic yo-yos? \nA: Basic yo-yos have wider gaps and lower response than those of 2A yo-yos, which makes Basic yo-yos can be used to play some easy basic tricks(including some easy string tricks like Trapeze， Double or Nothing)",
    "sourceInclude": "2pcs",
    "sourceColors": [
      "Basic spacers(2pcs)"
    ]
  },
  "17": {
    "sourceName": "Response Pad(OD 19MM)",
    "sourceDescription": "This response pad is suitable for most modern yo-yos(1A, 3A, 4A and 5A, except for 2A)",
    "sourceInclude": "2pcs",
    "sourceColors": [
      "Response Pad(OD 19mm)"
    ]
  },
  "18": {
    "sourceName": "Bearing",
    "sourceDescription": "If you don't know what size of these bearings you need, plaese contact us to confirm the size of original bearing inside your yo-yos  before purchasing!!!\n\nReference information: \nSize A: suitable for numbers of Duncan yo-yos;\nSize C: suitable for most modern yo-yos(1A, 3A, 4A and 5A)\nSize D: suitable for numbers of Hspin yo-yos;\nSize K: suitable for most modern 2A yo-yos(like Blitzball, Windball, Loop720);",
    "sourceInclude": "1pcs",
    "sourceColors": [
      "Size A Bearing",
      "Size C Bearing( Concave)",
      "Size D Bearing( Concave)",
      "Size K Bearing",
      "Size C Bearing( Advanced, Concave)"
    ]
  },
  "19": {
    "sourceName": "1345A String(Thick) x100",
    "sourceDescription": "These are thick strings(24 strands) suitable for playing 1A, 3A, 4A and 5A tricks.",
    "sourceInclude": "100 strings",
    "sourceColors": [
      "Yellow 113cm",
      "Yellow 130cm",
      "White 113cm",
      "White 130cm",
      "Green 113cm",
      "Green 130cm",
      "Orange 113cm",
      "Orange 130cm",
      "Pink 113cm",
      "Pink 130cm"
    ]
  },
  "20": {
    "sourceName": "Loop Infinity S",
    "sourceDescription": "A high-performance 2A yo-yo.\nPerfect for those who aspire to take their yo-yo skills to the next level.\nincludes: 2 Large shims, 2 Small shims for axle gap adjustment.",
    "sourceInclude": "includes: 2 Large shims, 2 Small shims for axle gap adjustment.",
    "sourceColors": [
      "Transparent Body Blue Cap Black Logo",
      "Transparent Body Yellow Cap Black Logo",
      "Transparent Body Transparent Cap Black Logo"
    ]
  },
  "21": {
    "sourceName": "Rainbow Windball",
    "sourceDescription": "Designed for speed, the Wind Ball is a high-performance yo-yo perfect for mastering fast-paced 2A division tricks.",
    "sourceInclude": "Default setup: Orange Red spacer + Deep Blue spacer( both not fit to BlitzBall). Additional 6 shims includeed: 2 Large shims(0.1mm), 2 Small shims(0.1mm), 2 Special shims(0.05mm).",
    "sourceColors": [
      "Rainbow Solid White Cap",
      "Rainbow Jade Cap",
      "Rainbow Transparent  Cap",
      "Rainbow Transparent Red Cap",
      "Rainbow Transparent Cyan Cap",
      "Rainbow Solid Black Cap",
      "Rainbow Solid Red Cap",
      "Rainbow Transparent Black Cap"
    ]
  },
  "22": {
    "sourceName": "Sunshine",
    "sourceDescription": "Signature Yo-Yo of AODA",
    "sourceInclude": "One Sunhine Yo-Yo",
    "sourceColors": [
      "Black",
      "Siliver",
      "Yellow"
    ]
  },
  "23": {
    "sourceName": "2A POM Spacer(2pcs)",
    "sourceDescription": "Fit for Yomega Raider, Fireball, Loop up and so on.\nIf you feel it's a little thick, you can polish it slightly.",
    "sourceInclude": "",
    "sourceColors": [
      "2A POM Spacer(2pcs)"
    ]
  }
};

export const CATALOG_COLLECTIONS = [
  { category: 'looping', path: '/collections/2a-yoyos' },
  { category: 'offstring', path: '/collections/offstring-yoyos' },
  { category: 'string', path: '/collections/string-trick-yoyos' },
  { category: 'parts', path: '/collections/yoyo-parts' },
];

const matchesCuratedSource = (product) => {
  const source = curatedSources[product.id];
  return source && product.name === source.sourceName
    && (product.description || '') === source.sourceDescription
    && (product.include || '') === source.sourceInclude
    && JSON.stringify((product.colors || []).map(({ name }) => name)) === JSON.stringify(source.sourceColors);
};

export const getCuratedCollection = (product) => {
  const copy = productCopy[product?.id];
  return copy && matchesCuratedSource(product) ? CATALOG_COLLECTIONS.find((item) => item.category === copy.category) : null;
};

export const getCatalogCopy = (product, t) => {
  if (!product) return null;
  const copy = productCopy[product.id];
  const matchesSource = matchesCuratedSource(product);
  if (!copy || !matchesSource) return {
    title: t('catalog.productTitle', { name: product.name, category: t('catalog.category.generic') }),
    description: product.description || t('catalog.genericDescription', { name: product.name }),
    details: product.include || t('product.faq.includedFallback'),
    collection: null,
  };
  const category = t(`catalog.category.${copy.category}`);
  return {
    title: t('catalog.productTitle', { name: product.name, category }),
    description: t(`catalog.product.${product.id}`),
    details: t(`catalog.details.${copy.details}`),
    collection: CATALOG_COLLECTIONS.find((item) => item.category === copy.category),
  };
};

export const getCatalogFaqs = (product, copy, t, formatPrice, price) => product && copy ? [
  { question: t('product.faq.suitableQuestion', { name: product.name }), answer: copy.description },
  { question: t('product.faq.includedQuestion', { name: product.name }), answer: copy.details },
  {
    question: t('product.faq.priceQuestion', { name: product.name }),
    answer: t('catalog.priceAnswer', { price: formatPrice(price) }),
  },
] : [];
